<p-confirmDialog #cd [style]="{width: '450px'}" appendTo="body" [closable]="false" styleClass="custom-confirm-dialog">
    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-3 w-full">
            <div class="flex align-items-center justify-content-center border-circle"
                style="width: 42px; height: 42px; background: #FEF2F2;">
                <i class="pi pi-trash text-red-500 text-xl"></i>
            </div>
            <span class="font-bold text-xl text-900">Remove Mentor?</span>
        </div>
    </ng-template>
    <ng-template pTemplate="message" let-message>
        <div class="flex flex-column gap-2 mt-2 pl-1">
            <span class="text-700 font-medium line-height-3" style="font-size: 15px;">{{message.message}}</span>
            <span class="text-xs text-500">This action will remove the mentor from your list. You will need to request a
                connection again if you change your mind.</span>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2 w-full pt-2">
            <button pButton label="Cancel" class="p-button-text p-button-plain font-bold text-gray-600"
                style="font-size: 14px;" (click)="cd.reject()"></button>
            <button pButton label="Yes, Remove" class="p-button-danger border-round-lg px-4 font-bold"
                style="background: #EF4444; border: none; font-size: 14px; height: 40px;"
                (click)="cd.accept()"></button>
        </div>
    </ng-template>
</p-confirmDialog>

<div class="w-full flex flex-column gap-4">
    <div class="w-full flex flex-column gap-4">
        <div class="w-full flex flex-column gap-2">
            <div class="flex xl:flex-row flex-column-reverse w-full">
                <!-- Show Calendar View when there are mentors, otherwise show mentor list -->
                <ng-container *ngIf="hasApprovedMentor; else mentorList">
                    <div class="container_width mx-auto col-12 p-0 flex flex-column gap-5">
                        <!-- New Horizontal Section: My Mentors & Upcoming Tasks -->
                        <div class="flex flex-column lg:flex-row gap-4 w-full">
                            <!-- Left Card: My Mentors -->
                            <div class="flex-1 p-5 border-round-2xl text-white flex flex-column justify-content-between"
                                style="background-color: #020054; min-height: 250px; box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.05);">
                                <div class="flex flex-column gap-3">
                                    <h3 class="m-0 font-bold"
                                        style="color: #D9DA5F; font-size: 24px; font-family: 'Poppins', sans-serif;">My
                                        Mentors</h3>

                                    <div class="flex align-items-center gap-4 mt-2"
                                        *ngFor="let mentor of studentMentors; let i = index;">
                                        <div class="border-circle overflow-hidden flex-shrink-0"
                                            style="width: 100px; height: 100px; border: 3px solid #CDD12A;">
                                            <img [src]="mentor.imageUrl || '../../../assets/images/avatar1.jpg'"
                                                alt="Mentor Image" class="w-full h-full object-cover">
                                        </div>

                                        <div class="flex flex-column gap-2">
                                            <h2 class="m-0 font-bold text-2xl"
                                                style="font-family: 'Poppins', sans-serif;">{{ mentor.firstName }} {{
                                                mentor.lastName }}</h2>
                                            <p class="m-0 font-medium text-sm flex align-items-center gap-2"
                                                style="color: rgba(255, 255, 255, 0.8);">
                                                <i class="pi pi-graduation-cap"></i>
                                                {{ mentor.mastersCollageName != '' ? mentor.mastersCollageName :
                                                mentor.graduationCollageName }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex justify-content-end gap-3 mt-4"
                                    *ngFor="let mentor of studentMentors; let i = index;">
                                    <a [routerLink]="['/portal', 'chat']"
                                        class="flex align-items-center justify-content-center gap-2 font-bold no-underline cursor-pointer border-round-3xl px-4 py-2"
                                        style="background-color: #CDD12A; color: #000086; font-size: 15px;">
                                        <i class="pi pi-comments"></i> Chat
                                    </a>
                                    <button (click)="removeMyMentor(mentor, i)"
                                        class="p-button p-button-danger flex align-items-center justify-content-center gap-2 font-bold border-none cursor-pointer border-round-3xl px-4 py-2"
                                        style="background-color: #EF4444; color: white; font-size: 15px;">
                                        <i class="pi pi-trash"></i> Delete
                                    </button>
                                </div>
                            </div>

                            <!-- Right Card: Upcoming Tasks -->
                            <div class="flex-1 p-5 border-round-2xl bg-white border-1 border-200 flex flex-column justify-content-between"
                                style="min-height: 250px; box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.05);">
                                <div class="flex flex-column gap-4 w-full">
                                    <!-- Card Title Header -->
                                    <div class="flex align-items-center justify-content-between w-full">
                                        <div class="relative inline-block">
                                            <h3 class="m-0 font-bold"
                                                style="color: #000086; font-size: 24px; font-family: 'Poppins', sans-serif;">
                                                Upcoming Tasks</h3>
                                            <div
                                                style="width: 40px; height: 4px; background-color: #D9DA5F; position: absolute; bottom: -6px; left: 0; border-radius: 2px;">
                                            </div>
                                        </div>

                                        <!-- Dropdown Filter -->
                                        <div>
                                            <p-dropdown [options]="taskTypeOptions" [(ngModel)]="selectedTaskType"
                                                (onChange)="onTaskTypeChange()" placeholder="All Tasks"
                                                styleClass="border-round-2xl border-none bg-indigo-50"
                                                [style]="{'min-width': '120px'}">
                                                <ng-template pTemplate="selectedItem">
                                                    <div class="flex align-items-center gap-2"
                                                        style="color: #000086; font-weight: 600; font-size: 13px;">
                                                        <span>{{ selectedTaskType === null ? 'All Tasks' :
                                                            getTaskTypeName(selectedTaskType) }}</span>
                                                    </div>
                                                </ng-template>
                                                <ng-template let-option pTemplate="item">
                                                    <span style="color: #000086; font-weight: 500; font-size: 13px;">{{
                                                        option.label }}</span>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                    </div>

                                    <!-- Checklist -->
                                    <div class="flex flex-column gap-2 mt-2 overflow-y-auto pr-1"
                                        style="max-height: 250px;">
                                        <!-- Dynamic Upcoming Tasks list -->
                                        <ng-container *ngIf="upcomingTasks.length > 0; else noTasks">
                                            <div *ngFor="let task of upcomingTasks; let last = last"
                                                (click)="onUpcomingTaskClick(task)"
                                                class="flex align-items-center justify-content-between py-3 cursor-pointer transition-colors transition-duration-200 hover:bg-gray-50 px-2 border-round-lg"
                                                [ngClass]="{'border-bottom-1 border-100': !last}">
                                                <div class="flex align-items-center gap-3 min-width-0 flex-1">
                                                    <!-- Minimal Solid Dot with Task Type Color -->
                                                    <div class="border-circle flex-shrink-0"
                                                        [style.background-color]="task.colourCode || '#000086'"
                                                        style="width: 8px; height: 8px; margin-left: 4px;">
                                                    </div>

                                                    <div class="flex flex-column gap-1 min-width-0 flex-1">
                                                        <span
                                                            class="font-semibold text-900 white-space-nowrap overflow-hidden text-overflow-ellipsis"
                                                            style="font-family: 'Sora', sans-serif; font-size: 14px; color: #111111;"
                                                            [title]="task.name">
                                                            {{ task.name }}
                                                        </span>
                                                        <div class="flex align-items-center gap-2 flex-wrap text-500 font-medium"
                                                            style="font-size: 11px; font-family: 'Sora', sans-serif; color: #718096;">
                                                            <span>{{ task.typeName }}</span>
                                                            <span style="color: #cbd5e1;">•</span>
                                                            <span>Due: {{ task.endDate | date: 'MMM d, yyyy' }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <i class="pi pi-chevron-right text-400"
                                                    style="color: #cbd5e1; font-size: 12px;"></i>
                                            </div>
                                        </ng-container>
                                        <ng-template #noTasks>
                                            <div class="text-center py-4 text-500 font-medium"
                                                style="font-family: 'Sora', sans-serif;">
                                                No upcoming tasks assigned.
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Calendar View -->
                        <app-calendar-view [userId]="currentUserId" [mentorId]="approvedMentorId"
                            [selectedTaskType]="selectedTaskType"
                            (upcomingTasksChange)="onUpcomingTasksLoaded($event)"></app-calendar-view>


                    </div>
                </ng-container>
                <ng-template #mentorList>
                    <div class="w-full flex flex-column">

                        <!-- Hero Section -->
                        <div class="w-full overflow-hidden relative bg-white pb-6"
                            style="margin-top: -2rem; padding-top: 4.5rem;">
                            <!-- Background Image -->
                            <img src="../../../assets/images/mentor_me_hero_section_background.png"
                                class="absolute top-0 right-0 h-full"
                                style="z-index: 0; object-fit: cover; object-position: right center; pointer-events: none; width: 900px !important;">

                            <!-- Inner constrained wrapper -->
                            <div class="container_width mx-auto w-full flex flex-column lg:flex-row relative z-1">
                                <!-- Left Content -->
                                <div class="w-full lg:w-6 py-4 pr-0 md:pr-6 flex flex-column justify-content-center">
                                    <!-- Decorative sparks -->
                                    <div class="mb-2">
                                        <svg width="40" height="40" viewBox="0 0 50 50" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 20 L5 10 M20 15 L15 5 M30 20 L35 10" stroke="#D9DA5F"
                                                stroke-width="4" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                    <h1
                                        style="color: #000086; font-size: 3.5rem; font-weight: 900; line-height: 1.1; margin: 0; font-family: 'Poppins', sans-serif;">
                                        Your Next Step<br>Starts With the Right<br>Mentor.
                                    </h1>
                                    <p class="mt-4 mb-5"
                                        style="color: #606060; font-size: 1.1rem; line-height: 1.6; max-width: 550px;">
                                        Chasing big dreams can feel overwhelming sometimes, whether you're just starting
                                        out or stuck in the middle, the right conversation can change everything.
                                        Connect with an expert mentor who truly understands your journey and can help
                                        you figure out 'what next?'
                                    </p>
                                    <div>
                                        <button (click)="scrollToMentors()"
                                            class="p-button font-bold border-none cursor-pointer"
                                            style="background-color: #000086; color: white; padding: 16px 32px; border-radius: 8px; font-size: 16px;">
                                            Connect to a Mentor
                                        </button>
                                    </div>
                                </div>

                                <!-- Right Image Grid -->
                                <div
                                    class="w-full lg:w-6 py-4 pl-0 md:pl-6 flex align-items-center justify-content-center lg:justify-content-end relative z-1">
                                    <div
                                        style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; width: 100%; max-width: 450px;">
                                        <img src="../../../assets/images/mentor_me_1.png"
                                            class="w-full object-cover shadow-2" style="aspect-ratio: 1;">
                                        <img src="../../../assets/images/mentor_me_2.png"
                                            class="w-full object-cover shadow-2"
                                            style="aspect-ratio: 1; border-radius: 50%;">
                                        <img src="../../../assets/images/mentor_me_3.png"
                                            class="w-full object-cover shadow-2" style="aspect-ratio: 1;">

                                        <img src="../../../assets/images/mentor_me_4.png"
                                            class="w-full object-cover shadow-2"
                                            style="aspect-ratio: 1; border-radius: 50%;">
                                        <img src="../../../assets/images/mentor_me_5.png"
                                            class="w-full object-cover shadow-2" style="aspect-ratio: 1;">
                                        <img src="../../../assets/images/mentor_me_6.png"
                                            class="w-full object-cover shadow-2"
                                            style="aspect-ratio: 1; border-radius: 50%;">

                                        <img src="../../../assets/images/mentor_me_7.png"
                                            class="w-full object-cover shadow-2" style="aspect-ratio: 1;">
                                        <img src="../../../assets/images/mentor_me_8.png"
                                            class="w-full object-cover shadow-2"
                                            style="aspect-ratio: 1; border-radius: 50%;">
                                        <img src="../../../assets/images/mentor_me_9.png"
                                            class="w-full object-cover shadow-2" style="aspect-ratio: 1;">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Steps Section -->
                        <div class="w-full" style="background-color: #D6E05E;">
                            <div
                                class="container_width mx-auto w-full flex flex-column lg:flex-row align-items-stretch py-3">
                                <!-- Step 1 -->
                                <div class="flex flex-row align-items-start gap-4 flex-1 p-3">
                                    <div class="flex align-items-center justify-content-center flex-shrink-0"
                                        style="width: 60px; height: 60px; background-color: #000086; color: white; font-size: 28px; font-weight: bold; border-radius: 50%;">
                                        1</div>
                                    <div class="flex flex-column">
                                        <h3 class="m-0 mb-2"
                                            style="color: #000086; font-size: 20px; font-weight: 800; font-family: 'Poppins', sans-serif;">
                                            Browse & Explore</h3>
                                        <p class="m-0"
                                            style="color: #2D3748; font-size: 14px; line-height: 1.4; font-weight: 500;">
                                            Go through our list of expert mentors and find someone you want to connect
                                            with.</p>
                                    </div>
                                </div>
                                <!-- Step 2 -->
                                <div class="flex flex-row align-items-start gap-4 flex-1 p-3">
                                    <div class="flex align-items-center justify-content-center flex-shrink-0"
                                        style="width: 60px; height: 60px; background-color: #000086; color: white; font-size: 28px; font-weight: bold; border-radius: 50%;">
                                        2</div>
                                    <div class="flex flex-column">
                                        <h3 class="m-0 mb-2"
                                            style="color: #000086; font-size: 20px; font-weight: 800; font-family: 'Poppins', sans-serif;">
                                            Send a Connection Request</h3>
                                        <p class="m-0"
                                            style="color: #2D3748; font-size: 14px; line-height: 1.4; font-weight: 500;">
                                            Hit connect and send a quick request with your question</p>
                                    </div>
                                </div>
                                <!-- Step 3 -->
                                <div class="flex flex-row align-items-start gap-4 flex-1 p-3">
                                    <div class="flex align-items-center justify-content-center flex-shrink-0"
                                        style="width: 60px; height: 60px; background-color: #000086; color: white; font-size: 28px; font-weight: bold; border-radius: 50%;">
                                        3</div>
                                    <div class="flex flex-column">
                                        <h3 class="m-0 mb-2"
                                            style="color: #000086; font-size: 20px; font-weight: 800; font-family: 'Poppins', sans-serif;">
                                            Wait for Confirmation</h3>
                                        <p class="m-0"
                                            style="color: #2D3748; font-size: 14px; line-height: 1.4; font-weight: 500;">
                                            Someone from our team will get in touch with you to set up your clarity
                                            call!</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Horizontal Stepper Outline -->
                        <div class="w-full mb-6 sticky top-0"
                            style="background-color: #FAFAEA; position: sticky; top: 0; z-index: 50;">
                            <div
                                class="container_width mx-auto w-full flex justify-content-center align-items-center py-5">
                                <div class="flex align-items-start justify-content-center w-full relative"
                                    style="max-width: 600px;">
                                    <!-- Connecting Line -->
                                    <div class="absolute"
                                        style="top: 20px; height: 2px; background-color: #D9DA5F; width: 66.66%; left: 16.66%; z-index: 0;">
                                    </div>

                                    <div class="flex flex-column align-items-center z-1" style="flex: 1;">
                                        <div class="flex align-items-center justify-content-center mb-2 transition-colors transition-duration-300"
                                            [style.backgroundColor]="currentStep >= 1 ? '#000086' : '#A0AEC0'"
                                            style="width: 40px; height: 40px; color: white; border-radius: 50%; font-weight: bold; font-size: 18px;">
                                            1</div>
                                        <span class="text-xs text-center transition-colors transition-duration-300"
                                            [ngClass]="currentStep >= 1 ? 'font-bold' : 'font-medium'"
                                            [style.color]="currentStep >= 1 ? '#000000' : '#A0AEC0'">Scroll the Mentor
                                            List</span>
                                    </div>
                                    <div class="flex flex-column align-items-center z-1" style="flex: 1;">
                                        <div class="flex align-items-center justify-content-center mb-2 transition-colors transition-duration-300"
                                            [style.backgroundColor]="currentStep >= 2 ? '#000086' : '#A0AEC0'"
                                            style="width: 40px; height: 40px; color: white; border-radius: 50%; font-weight: bold; font-size: 18px;">
                                            2</div>
                                        <span class="text-xs text-center transition-colors transition-duration-300"
                                            [ngClass]="currentStep >= 2 ? 'font-bold' : 'font-medium'"
                                            [style.color]="currentStep >= 2 ? '#000000' : '#A0AEC0'">Send a
                                            request</span>
                                    </div>
                                    <div class="flex flex-column align-items-center z-1" style="flex: 1;">
                                        <div class="flex align-items-center justify-content-center mb-2 transition-colors transition-duration-300"
                                            [style.backgroundColor]="currentStep >= 3 ? '#000086' : '#A0AEC0'"
                                            style="width: 40px; height: 40px; color: white; border-radius: 50%; font-weight: bold; font-size: 18px;">
                                            3</div>
                                        <span class="text-xs text-center transition-colors transition-duration-300"
                                            [ngClass]="currentStep >= 3 ? 'font-bold' : 'font-medium'"
                                            [style.color]="currentStep >= 3 ? '#000000' : '#A0AEC0'">Wait for
                                            Confirmation</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Constrained Content Area -->
                        <div class="container_width mx-auto w-full flex flex-column">
                            
                            <!-- CTA Banner -->
                            <div class="w-full flex justify-content-center py-4 mt-2 px-2">
                                <div class="w-full relative flex align-items-center shadow-4"
                                    style="border-radius: 16px; overflow: hidden; background-color: #020054; height: 200px;">
                                    <!-- Background Image -->
                                    <img src="../../../assets/images/inline-cta-strip-1.png"
                                        class="absolute top-0 left-0 w-full h-full" style="object-fit: fill; z-index: 0;"
                                        alt="Background">

                                    <!-- Content Overlay -->
                                    <div class="relative z-1 flex flex-column md:flex-row align-items-center w-full h-full py-4 px-4 md:px-6">
                                        <!-- Spacer for illustration on the left -->
                                        <div class="hidden md:block" style="width: 28%;"></div>

                                        <!-- Text Content -->
                                        <div class="flex flex-column text-white flex-1 px-3 text-center md:text-left z-1">
                                            <h2 class="m-0 mb-2" style="font-size: 24px; font-weight: 700;">
                                                Not sure which Mentor is right <span style="color: #D9DA5F;">for your
                                                    goals?</span>
                                            </h2>
                                            <p class="m-0"
                                                style="font-size: 15px; color: #E0E0E0; max-width: 550px; line-height: 1.5;">
                                                Book a strategy call and our team will understand your needs and point you
                                                in the right direction.
                                            </p>
                                        </div>

                                        <!-- Button -->
                                        <div class="mt-4 md:mt-0 flex-shrink-0 z-1 md:pr-4">
                                            <button class="font-bold border-none cursor-pointer"
                                                style="background-color: #CDD12A; color: #000086; padding: 12px 24px; border-radius: 16px; font-size: 20px; width: 300px; height: 60px;"
                                                (click)="showClarityCallDialog = true">
                                                Book My Clarity Call
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Page Title -->
                            <div id="our-mentors-section" class="w-full flex justify-content-center mb-5 mt-4">
                                <div class="text-center relative inline-block">
                                    <h1
                                        style="color: #000086; font-size: 48px; font-weight: 900; font-family: 'Poppins', sans-serif; margin: 0; position: relative; z-index: 1;">
                                        Our Mentors</h1>
                                    <!-- Underline -->
                                    <div
                                        style="width: 60%; height: 5px; background-color: #D9DA5F; position: absolute; bottom: -10px; left: 20%; border-radius: 4px;">
                                    </div>
                                </div>
                            </div>

                            <div class="flex flex-wrap col-12 p-0">
                                <!--Skeleton-->
                                <ng-container *ngIf="isLoadingMentor;else loadedContent">
                                    <div *ngFor="let _ of [].constructor(3); let i = index" class="col-12 py-3">
                                        <div class="w-full bg-white flex flex-column md:flex-row gap-4 p-0 overflow-hidden relative"
                                            style="box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.06); border-radius: 30px;">
                                            <div class="w-full md:w-4 lg:w-3 flex-shrink-0" style="min-height: 250px;">
                                                <p-skeleton width="100%" height="100%" />
                                            </div>
                                            <div class="w-full md:w-8 lg:w-9 flex flex-column gap-3 p-4">
                                                <p-skeleton width="40%" height="2.5rem" />
                                                <p-skeleton width="60%" height="1.5rem" />
                                                <div class="flex gap-2 mt-2">
                                                    <p-skeleton width="120px" height="2.5rem" borderRadius="30px" />
                                                    <p-skeleton width="120px" height="2.5rem" borderRadius="30px" />
                                                </div>
                                                <p-skeleton width="100%" height="4rem" />
                                                <div class="flex justify-content-between align-items-end mt-auto pt-3">
                                                    <p-skeleton width="150px" height="2rem" />
                                                    <div class="flex gap-3">
                                                        <p-skeleton width="120px" height="3rem" borderRadius="12px" />
                                                        <p-skeleton width="120px" height="3rem" borderRadius="12px" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <!--Skeleton-->
                                <ng-template #loadedContent>
                                    <div *ngFor="let mentor of mentors;let i = index;" class="col-12 py-3">
                                        <div class="w-full flex flex-column md:flex-row bg-white overflow-hidden relative"
                                            style="box-shadow: 0px 10px 52px rgba(0, 0, 0, 0.06); border-radius: 30px;">
                                            <!-- Background Watermark -->
                                            <!-- Background Watermark -->
                                            <div *ngIf="mentor.experience"
                                                class="absolute hidden lg:flex flex-column align-items-end"
                                                style="right: 20px; top: 10px; z-index: 0; pointer-events: none;">
                                                <div
                                                    style="color: #000086; opacity: 0.04; font-size: 160px; line-height: 0.8; letter-spacing: -3px; margin-right: 10px; font-weight: 900; font-family: 'Poppins', sans-serif;">
                                                    {{ formatExperience(mentor.experience) }}+
                                                </div>
                                                <div class="font-bold text-sm"
                                                    style="color: #B6B6D2; margin-top: 15px; margin-right: 20px; z-index: 1; opacity: 0.5;">
                                                    Years of Experience</div>
                                            </div>

                                            <!-- Left: Image Section -->
                                            <div class="relative w-full md:w-5 lg:w-4 flex-shrink-0 flex"
                                                style="min-height: 350px; max-height: 350px; max-width: 340px; overflow: hidden; align-self: flex-start; border-radius: 30px;">
                                                <!-- Top Mentor Badge -->
                                                <div class="absolute top-0 left-0 m-4 px-3 py-2 bg-white flex align-items-center gap-2 z-1"
                                                    style="border-radius: 30px; box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.10); opacity: 0.95;">
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                                        stroke="#FE9A00" stroke-width="2.5" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <circle cx="12" cy="8" r="7"></circle>
                                                        <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88">
                                                        </polyline>
                                                    </svg>
                                                    <span class="font-semibold"
                                                        style="color: #1E2939; font-size: 15px;">Top Mentor</span>
                                                </div>
                                                <img [src]="mentor.imageUrl || '../../../assets/images/avatar1.jpg'"
                                                    class="w-full h-full object-cover" style="min-height: 100%;"
                                                    alt="Mentor Image">
                                            </div>

                                            <!-- Right: Content Section -->
                                            <div class="flex flex-column flex-1 w-full z-1 relative gap-3 p-5 md:p-5 justify-content-center"
                                                style="min-width: 0;">
                                                <!-- Name -->
                                                <div
                                                    style="color: #000086; font-size: 36px; font-weight: 800; font-family: 'Poppins', sans-serif; line-height: 1.1; letter-spacing: -0.5px;">
                                                    {{mentor.firstName}} {{mentor.lastName}}</div>

                                                <!-- College Info -->
                                                <div class="flex align-items-center gap-2">
                                                    <i class="pi pi-graduation-cap text-xl" style="color: #000086;"></i>
                                                    <span class="font-medium" style="color: #444444; font-size: 15px;">
                                                        {{mentor.mastersCollageName != '' ? mentor.mastersCollageName :
                                                        mentor.graduationCollageName}}
                                                    </span>
                                                </div>

                                                <!-- Services Specialization -->
                                                <div class="flex flex-wrap gap-2 mt-1" style="max-width: 80%;"
                                                    *ngIf="mentor.servicesSpecialization?.length">
                                                    <div *ngFor="let service of mentor.servicesSpecialization"
                                                        class="flex align-items-center justify-content-center"
                                                        style="padding: 8px 18px; background: #FAF9FF; box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.08); border-radius: 40px; color: #111111; font-weight: 500; font-size: 14px;">
                                                        {{service}}
                                                    </div>
                                                </div>

                                                <!-- Subject Specialization -->
                                                <div class="flex flex-wrap gap-2 mt-0" style="max-width: 80%;"
                                                    *ngIf="mentor.subjectSpecialization?.length">
                                                    <div *ngFor="let subject of mentor.subjectSpecialization"
                                                        class="flex align-items-center justify-content-center gap-2"
                                                        style="padding: 8px 18px; background: white; box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.08); border-radius: 40px; color: #111111; font-weight: 500; font-size: 14px;">
                                                        <ng-container [ngSwitch]="subject">
                                                            <img *ngSwitchCase="'Business'"
                                                                src="../../../assets/images/subject_specilization_business.png"
                                                                alt="Business"
                                                                style="width: 14px; height: 14px; object-fit: contain;">
                                                            <img *ngSwitchCase="'Transfer'"
                                                                src="../../../assets/images/subject_specilization_transfer.png"
                                                                alt="Transfer"
                                                                style="width: 14px; height: 14px; object-fit: contain;">
                                                            <img *ngSwitchCase="'Athletics'"
                                                                src="../../../assets/images/subject_specilization_athletics.png"
                                                                alt="Athletics"
                                                                style="width: 14px; height: 14px; object-fit: contain;">
                                                            <img *ngSwitchCase="'Performing Arts'"
                                                                src="../../../assets/images/subject_specilization_perform,ing arts.png"
                                                                alt="Performing Arts"
                                                                style="width: 14px; height: 14px; object-fit: contain;">
                                                        </ng-container>
                                                        {{subject}}
                                                    </div>
                                                </div>

                                                <!-- Bio text -->
                                                <div class="mt-1 line-height-3 pr-3 w-full"
                                                    style="color: #606060; font-size: 15px; max-width: 100%; overflow-wrap: break-word; word-break: normal; white-space: pre-line; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                                                    [innerHTML]="mentor.whyToBeMentor || ''">
                                                </div>

                                                <!-- Bottom Area -->
                                                <div
                                                    class="flex flex-column lg:flex-row lg:align-items-end justify-content-between mt-3 flex-wrap gap-3">
                                                    <div class="flex flex-column gap-1"
                                                        *ngIf="mentor.topAdmits?.length">
                                                        <div class="font-semibold"
                                                            style="color: black; font-size: 18px;">Top admits</div>
                                                        <div class="flex gap-3 align-items-center mt-2 flex-wrap">
                                                            <img *ngFor="let admit of mentor.topAdmits | slice:0:4"
                                                                [src]="admit.logoUrl" class="object-contain"
                                                                style="width: 44px; height: 44px;"
                                                                [title]="admit.instituteName"
                                                                onerror="this.style.display='none'">
                                                            <div *ngIf="mentor.topAdmits && mentor.topAdmits.length > 4"
                                                                class="flex align-items-center justify-content-center"
                                                                style="width: 44px; height: 44px; border-radius: 50%; background-color: #F4F4FA; color: #000086; font-weight: 800; font-size: 14px; border: 1px solid rgba(0,0,134,0.1); box-shadow: 0 2px 4px rgba(0,0,0,0.03);">
                                                                +{{ mentor.topAdmits.length - 4 }}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="flex gap-3 align-items-center z-1 w-full lg:w-auto flex-wrap justify-content-end lg:ml-auto">
                                                        <div *ngIf="studentMentors.length === 0">
                                                            <ng-container [ngSwitch]="mentor.status">
                                                                <p-button
                                                                    *ngSwitchCase="StudentMentorRequestStatus.Pending"
                                                                    label="Pending Approval" [disabled]="true"
                                                                    styleClass="border-none font-medium"
                                                                    [style]="{'border-radius': '10px', 'padding': '12px 24px', 'font-size': '15px'}">
                                                                </p-button>

                                                                <p-button
                                                                    *ngSwitchCase="StudentMentorRequestStatus.Rejected"
                                                                    label="Request Rejected" [disabled]="true"
                                                                    styleClass="p-button-danger border-none font-medium"
                                                                    [style]="{'border-radius': '10px', 'padding': '12px 24px', 'font-size': '15px'}">
                                                                </p-button>

                                                                <p-button *ngSwitchDefault label="Connect now"
                                                                    [disabled]="isAnyMentorPending"
                                                                    [loading]="mentorLoadingIndex==i"
                                                                    styleClass="border-none font-medium"
                                                                    [style]="{'background-color': '#000086', 'color': 'white', 'border-radius': '10px', 'padding': '12px 24px', 'font-size': '15px'}"
                                                                    (onClick)="showDialog(mentor,i)">
                                                                </p-button>
                                                            </ng-container>
                                                        </div>
                                                        <a *ngIf="mentor.status === StudentMentorRequestStatus.Approved && (studentMentors==null || studentMentors.length==0)"
                                                            [routerLink]="['/portal','schedule-call',mentor.userId]"
                                                            routerLinkActive="router-link-active"
                                                            class="font-medium text-white no-underline text-center"
                                                            style="background-color: #000086; border-radius: 10px; padding: 12px 24px; font-size: 15px;">Schedule
                                                            a call</a>

                                                        <a [routerLink]="['/portal','mentor-profile', mentor.userId]"
                                                            class="font-medium text-black-alpha-90 no-underline text-center"
                                                            style="background-color: #D9DA5F; border-radius: 10px; padding: 12px 24px; font-size: 15px;">Know
                                                            more</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- CTA Banner -->
                                    <div *ngIf="mentors && mentors.length > 0"
                                        class="w-full flex justify-content-center py-4 mt-2 px-2">
                                        <div class="w-full relative flex align-items-center shadow-4"
                                            style="border-radius: 16px; overflow: hidden; background-color: #020054; height: 200px;">
                                            <!-- Background Image -->
                                            <img src="../../../assets/images/inline-cta-strip-1.png"
                                                class="absolute top-0 left-0 w-full h-full"
                                                style="object-fit: fill; z-index: 0;" alt="Background">

                                            <!-- Content Overlay -->
                                            <div
                                                class="relative z-1 flex flex-column md:flex-row align-items-center w-full h-full py-4 px-4 md:px-6">
                                                <!-- Spacer for illustration on the left -->
                                                <div class="hidden md:block" style="width: 28%;"></div>

                                                <!-- Text Content -->
                                                <div
                                                    class="flex flex-column text-white flex-1 px-3 text-center md:text-left z-1">
                                                    <h2 class="m-0 mb-2" style="font-size: 24px; font-weight: 700;">
                                                        Not sure which Mentor is right <span style="color: #D9DA5F;">for
                                                            your goals?</span>
                                                    </h2>
                                                    <p class="m-0"
                                                        style="font-size: 15px; color: #E0E0E0; max-width: 550px; line-height: 1.5;">
                                                        Book a strategy call and our team will understand your needs and
                                                        point you in the right direction.
                                                    </p>
                                                </div>

                                                <!-- Button -->
                                                <div class="mt-4 md:mt-0 flex-shrink-0 z-1 md:pr-4">
                                                    <button class="font-bold border-none cursor-pointer"
                                                        style="background-color: #CDD12A; color: #000086; padding: 12px 24px; border-radius: 16px; font-size: 20px; width: 300px; height: 60px;"
                                                        (click)="showClarityCallDialog = true">
                                                        Book My Clarity Call
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngIf="mentors && mentors.length==0"
                                        class="w-full flex flex-column align-items-center py-4 gap-5">
                                        <div class="w-full flex align-items-center justify-content-center">
                                            <img src="../../../assets/icons/nodatafound.svg" alt=""
                                                class="w-full max-w-16rem">
                                        </div>
                                        <b class="text-center font-normal text-2xl" style="color: #000086;">No Data
                                            Found !</b>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <p-dialog [modal]="true" [(visible)]="visible" (onHide)="closeDialog()" [showHeader]="false"
                    [style]="{ width: '930px', maxWidth: '95vw', borderRadius: '35px', background: 'transparent', border: 'none', boxShadow: 'none' }"
                    [contentStyle]="{ background: 'transparent', padding: '0', borderRadius: '35px', overflow: 'hidden' }"
                    maskStyleClass="custom-dialog-mask">

                    <div class="relative w-full flex flex-column overflow-hidden p-4 md:p-6"
                        style="background: linear-gradient(223deg, #000086 0%, #0909A8 100%); min-height: 650px; border-radius: 35px;">

                        <!-- Close Button -->
                        <button (click)="closeDialog()"
                            class="absolute cursor-pointer bg-transparent border-none text-white hover:text-gray-300 transition-colors z-5"
                            style="top: 24px; right: 24px; font-size: 24px;">
                            ✕
                        </button>

                        <!-- Top Section (Text + Image) -->
                        <div class="flex flex-column w-full mb-6 relative z-2 flex-grow-1" style="margin-top: 10px;">
                            <!-- Text Content -->
                            <div class="flex flex-column w-full z-2">
                                <h2 class="text-4xl md:text-6xl"
                                    style="color: #FDFF77; font-weight: 700; line-height: 1.2; margin: 0 0 20px 0;">
                                    Been overthinking?<br>Drop it here.
                                </h2>
                                <p class="text-lg md:text-xl"
                                    style="color: white; font-weight: 200; line-height: 1.6; margin: 0; max-width: 550px; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;">
                                    You don’t have to sort everything alone, neither do you have to have everything
                                    figured out. Just share where you’re at, and we’ll help you take the right next
                                    step.
                                </p>
                            </div>

                            <!-- Paper Plane Image -->
                            <div class="hidden md:flex absolute"
                                style="right: -70px; top: 40px; z-index: 1; pointer-events: none; rotate: -0deg; width: 250px;">
                                <img src="../../../assets/images/contact_up_pop_up_plane.png" alt="Paper plane"
                                    style="max-width: 350px;">
                            </div>
                        </div>

                        <!-- Text Area Section -->
                        <div class="relative w-full mt-auto z-2"
                            style="border-radius: 14px; background: white; padding: 4px; border: 7px solid #CDD12A; box-shadow: -6px 6px 0px #CDD12A; height: 225px; margin-bottom: 6px;">
                            <textarea class="w-full border-none outline-none p-4" [(ngModel)]="purposeToConnect"
                                rows="6" placeholder="Type your query here"
                                style="resize: none; border-radius: 10px; font-size: 20px; line-height: 32.4px; color: #333; background: transparent; height: 100%;"></textarea>

                            <small class="text-white block absolute font-semibold" style="bottom: -30px; left: 10px;"
                                *ngIf="submitted && !purposeToConnect">
                                Query is required
                            </small>

                            <!-- Send Button -->
                            <button
                                class="absolute cursor-pointer border-none text-white flex align-items-center justify-content-center"
                                [disabled]="!purposeToConnect || isLoading" (click)="requestMentor()"
                                style="bottom: 16px; right: 16px; background: linear-gradient(140deg, #883DF9 0%, #8931DB 100%); border-radius: 8px; padding: 8px 30px; font-size: 20px; font-weight: 500; line-height: 32.4px; transition: opacity 0.2s; z-index: 5;">
                                <span *ngIf="!isLoading">Send</span>
                                <i *ngIf="isLoading" class="pi pi-spin pi-spinner ml-2"></i>
                            </button>
                        </div>
                    </div>
                </p-dialog>

           
                <app-clarity-call-popup
                    [(visible)]="showClarityCallDialog"
                    [contactPurpose]="ContactPurpose.MentorClarityCall">
                </app-clarity-call-popup>